// extracted by mini-css-extract-plugin
module.exports = {"rating":"Lc","numberOfStars":"Mc"};